module.exports = __webpack_public_path__ + "static/media/kyte_logo.24e6e5c1.svg";